module.exports = __webpack_public_path__ + "static/portfolio-image-7-58f49d2d4c44e06fbc74591ec08ffd59.jpg";